var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "div",
        { staticStyle: { float: "left" } },
        [
          _vm.filtrosAplicados.length > 0
            ? _c(
                "vs-chip",
                {
                  staticStyle: { cursor: "pointer" },
                  attrs: { "data-cy": "setFilters" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.setFilters()
                    }
                  }
                },
                [
                  _c("vs-avatar", {
                    attrs: {
                      icon: "search",
                      color: "primary",
                      badge: _vm.filtrosAplicados.length
                    }
                  }),
                  _c("strong", [_vm._v("Buscar")])
                ],
                1
              )
            : _vm._e(),
          !_vm.filtrosAplicados.length
            ? _c(
                "vs-chip",
                {
                  staticStyle: { cursor: "pointer" },
                  attrs: { color: "gray" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.setFilters()
                    }
                  }
                },
                [
                  _c("vs-avatar", { attrs: { icon: "search", color: "#ccc" } }),
                  _c(
                    "strong",
                    { attrs: { "data-cy": "search-without-filters" } },
                    [_vm._v("Buscar sin filtros aplicados ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasQueryFilters
            ? _c(
                "vs-chip",
                {
                  staticStyle: { cursor: "context-menu" },
                  attrs: { color: _vm.colores.navbar },
                  nativeOn: {
                    click: function($event) {
                      return _vm.clearQueryFilters()
                    }
                  }
                },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "link", color: "primary" }
                  }),
                  _c("strong", [_vm._v("Borrar filtros de enlace")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { float: "right" } },
        [
          _c(
            "vs-dropdown",
            { attrs: { "vs-trigger-click": "", "data-cy": "add-filter" } },
            [
              _c(
                "vs-chip",
                { attrs: { color: "primary" } },
                [
                  _c("vs-avatar", { attrs: { icon: "add", color: "primary" } }),
                  _vm._v(" Agregar filtro ")
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                { staticClass: "scroll-options", attrs: { "data-cy": "list" } },
                [
                  _vm.filtrosDisponibles.length >=
                  _vm.showFilterOnNumberElements
                    ? _c("vs-input", {
                        attrs: {
                          type: "text",
                          "data-cy": "filter-input-search"
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    : _vm._e(),
                  _vm._l(_vm.avalaibleFiltersSearch, function(filter, index) {
                    return _c(
                      "vs-dropdown-item",
                      {
                        key: "filter-" + index,
                        staticStyle: { width: "200px" },
                        attrs: { "data-cy": "filter-" + filter.campo },
                        on: {
                          click: function($event) {
                            return _vm.addFilter(filter)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(filter.nombre) + " ")]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._l(_vm.filtrosAplicadosFiltered, function(filtro, index) {
        return _c(
          "vs-chip",
          {
            key: "filtro-aplicado-" + index,
            staticStyle: { cursor: "context-menu" },
            attrs: { color: "primary", transparent: "" }
          },
          [
            _c("vs-avatar", {
              attrs: { "data-cy": "clear", icon: "clear", color: "primary" },
              nativeOn: {
                click: function($event) {
                  return _vm.removeFilter(filtro)
                }
              }
            }),
            _c("span"),
            _c(
              "vs-tooltip",
              {
                attrs: { text: "Modificar filtro " + filtro.nombre },
                nativeOn: {
                  click: function($event) {
                    return _vm.modificarFiltro(filtro)
                  }
                }
              },
              [
                _c("strong", [_vm._v(_vm._s(filtro.nombre) + ": ")]),
                _c("span", { staticClass: "pl-1" }, [
                  _vm._v(" " + _vm._s(filtro.valorFormateado) + " ")
                ])
              ]
            )
          ],
          1
        )
      }),
      _c(
        "b-modal",
        {
          ref: "configFiltro",
          attrs: {
            title: "Filtrar por " + _vm.actualFilter.nombre,
            "no-close-on-backdrop": "",
            centered: "",
            "hide-footer": "",
            "hide-header-close": _vm.editMood
          },
          on: {
            cancel: function($event) {
              return _vm.closeModal(_vm.actualFilter)
            },
            close: function($event) {
              return _vm.closeModal(_vm.actualFilter)
            }
          }
        },
        [
          _c("div", [
            _vm.actualFilter.tipo === "creatingEntity"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.actualFilter.opciones },
                        model: {
                          value: _vm.filterOptions.creatingEntity,
                          callback: function($$v) {
                            _vm.$set(_vm.filterOptions, "creatingEntity", $$v)
                          },
                          expression: "filterOptions.creatingEntity"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "recipientEntity"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.actualFilter.opciones },
                        model: {
                          value: _vm.filterOptions.recipientEntity,
                          callback: function($$v) {
                            _vm.$set(_vm.filterOptions, "recipientEntity", $$v)
                          },
                          expression: "filterOptions.recipientEntity"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "selectorNotificado"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.actualFilter.opciones },
                        model: {
                          value: _vm.filterOptions.notified,
                          callback: function($$v) {
                            _vm.$set(_vm.filterOptions, "notified", $$v)
                          },
                          expression: "filterOptions.notified"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "estadoTramitacion"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.actualFilter.opciones },
                        model: {
                          value: _vm.filterOptions.status,
                          callback: function($$v) {
                            _vm.$set(_vm.filterOptions, "status", $$v)
                          },
                          expression: "filterOptions.status"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "estadoEtapa"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.actualFilter.opciones },
                        model: {
                          value: _vm.filterOptions.stage,
                          callback: function($$v) {
                            _vm.$set(_vm.filterOptions, "stage", $$v)
                          },
                          expression: "filterOptions.stage"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "selectorDistribuido"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.actualFilter.opciones },
                        model: {
                          value: _vm.filterOptions.distributed,
                          callback: function($$v) {
                            _vm.$set(_vm.filterOptions, "distributed", $$v)
                          },
                          expression: "filterOptions.distributed"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "documentType"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.actualFilter.opciones },
                        model: {
                          value: _vm.filterOptions.documentType,
                          callback: function($$v) {
                            _vm.$set(_vm.filterOptions, "documentType", $$v)
                          },
                          expression: "filterOptions.documentType"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo == "texto"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("b-form-input", {
                        staticClass: "w-100",
                        attrs: {
                          placeholder: "Agregar",
                          type: _vm.actualFilter.tipoInput || "text"
                        },
                        model: {
                          value: _vm.text,
                          callback: function($$v) {
                            _vm.text = $$v
                          },
                          expression: "text"
                        }
                      }),
                      _vm.actualFilter.mensaje
                        ? _c("small", [
                            _vm._v(" " + _vm._s(_vm.actualFilter.mensaje) + " ")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "text-center mt-2" },
            [
              _c(
                "vs-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.verificarFiltrosAlCerrar }
                },
                [_vm._v(" Confirmar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }